/** Retour KDS / prep → menu principal caisse (pas catalogue panier). */
export function buildCaisseAccueilHref(commercantId) {
  if (!commercantId) return '/caisse?posHub=accueil';
  const params = new URLSearchParams({
    commercantId: String(commercantId),
    posHub: 'accueil',
  });
  return `/caisse?${params.toString()}`;
}

export function readPosHubAccueilFromSearchParams(searchParams) {
  if (!searchParams) return false;
  if (typeof searchParams.get === 'function') {
    return searchParams.get('posHub') === 'accueil';
  }
  return false;
}
